import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './chat-message-time.style'

import dayjs from 'dayjs'

import { useIntl } from 'react-intl'

const ChatMessageTime = props => {
  const classes = useStyles(props)
  
  const { location, time, type } = props
  
  const intl = useIntl()

  const unixTime = dayjs(time).locale(intl.locale).format('h:mm:ss A [on] MMM D, YYYY')

  const messageTime = type === 'suggestion' ? `Sent with Location \u00B7 ${unixTime}` : `${unixTime} \u00B7 Current location requested`

  const withLocation = location && type !== 'tip-confirmation' ? messageTime : unixTime

  return (
    <div className={classes.container}>
      <span
        className={classes.text}
        data-testid='message-timestamp'
      >{withLocation}
      </span>
    </div>
  )
}

ChatMessageTime.defaultProps = {
  location: false,
  time: 0,
  type: ''
}

ChatMessageTime.propTypes = {
  location: PropTypes.bool,
  time: PropTypes.number,
  type: PropTypes.string
}

export default ChatMessageTime
